import { render, staticRenderFns } from "./IconSvgQr.vue?vue&type=template&id=5fc30dfa&scoped=true&"
import script from "./IconSvgQr.vue?vue&type=script&lang=js&"
export * from "./IconSvgQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc30dfa",
  null
  
)

export default component.exports